// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, headingColorOpt, colorOpt, hoverColorOpt, iconBackgroundColorOpt, iconHoverBackgroundColorOpt, iconColorOpt, iconHoverColorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.lilac50;
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.gray600;
  var hoverColor = hoverColorOpt !== undefined ? hoverColorOpt : Theme__Color$PrezzeeRibbon.gray600;
  var iconBackgroundColor = iconBackgroundColorOpt !== undefined ? iconBackgroundColorOpt : Theme__Color$PrezzeeRibbon.purple400;
  var iconHoverBackgroundColor = iconHoverBackgroundColorOpt !== undefined ? iconHoverBackgroundColorOpt : Theme__Color$PrezzeeRibbon.purple400;
  var iconColor = iconColorOpt !== undefined ? iconColorOpt : Theme__Color$PrezzeeRibbon.white;
  var iconHoverColor = iconHoverColorOpt !== undefined ? iconHoverColorOpt : Theme__Color$PrezzeeRibbon.white;
  return {
          backgroundColor: backgroundColor,
          headingColor: headingColor,
          color: color,
          hoverColor: hoverColor,
          iconBackgroundColor: iconBackgroundColor,
          iconHoverBackgroundColor: iconHoverBackgroundColor,
          iconColor: iconColor,
          iconHoverColor: iconHoverColor
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
